module.exports = __webpack_public_path__ + "static/media/OtherServices.a8b27b6f.svg";